import type { SelectChangeEvent } from '@mui/material';
import { MenuItem, Select } from '@mui/material';

export enum PartnerEvent {
  addPaymentInfo = 'AddPaymentInfo',
  addToCart = 'AddToCart',
  addToWishlist = 'AddToWishlist',
  completeRegistration = 'CompleteRegistration',
  contact = 'Contact',
  customizeProduct = 'CustomizeProduct',
  donate = 'Donate',
  findLocation = 'FindLocation',
  initiateCheckout = 'InitiateCheckout',
  lead = 'Lead',
  purchase = 'Purchase',
  schedule = 'Schedule',
  search = 'Search',
  startTrial = 'StartTrial',
  submitApplication = 'SubmitApplication',
  subscribe = 'Subscribe',
  viewContent = 'ViewContent',
}

const ITEMS: Record<PartnerEvent, string> = {
  [PartnerEvent.addPaymentInfo]: 'AddPaymentInfo',
  [PartnerEvent.addToCart]: 'AddToCart',
  [PartnerEvent.addToWishlist]: 'AddToWishlist',
  [PartnerEvent.completeRegistration]: 'CompleteRegistration',
  [PartnerEvent.contact]: 'Contact',
  [PartnerEvent.customizeProduct]: 'CustomizeProduct',
  [PartnerEvent.donate]: 'Donate',
  [PartnerEvent.findLocation]: 'FindLocation',
  [PartnerEvent.initiateCheckout]: 'InitiateCheckout',
  [PartnerEvent.lead]: 'Lead',
  [PartnerEvent.purchase]: 'Purchase',
  [PartnerEvent.schedule]: 'Schedule',
  [PartnerEvent.search]: 'Search',
  [PartnerEvent.startTrial]: 'StartTrial',
  [PartnerEvent.submitApplication]: 'SubmitApplication',
  [PartnerEvent.subscribe]: 'Subscribe',
  [PartnerEvent.viewContent]: 'ViewContent',
};

interface Props {
  value: PartnerEvent;
  onChange: (value: PartnerEvent) => void;
}

export function PartnerEventSelect({ value, onChange }: Props) {
  const handleChange = (event: SelectChangeEvent<PartnerEvent>) => {
    onChange(event.target.value as PartnerEvent);
  };

  return (
    <Select sx={{ width: 185 }} value={value} onChange={handleChange}>
      {Object.entries(ITEMS).map(([value, label]) => {
        return (
          <MenuItem key={value} value={value}>
            {label}
          </MenuItem>
        );
      })}
    </Select>
  );
}
